import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = ["content"]
const _hoisted_2 = ["content"]
const _hoisted_3 = ["content"]
const _hoisted_4 = ["content"]
const _hoisted_5 = ["content"]
const _hoisted_6 = ["content"]
const _hoisted_7 = { itemprop: "operatingSystem" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

import { computed, toRef } from 'vue'
import type { GameCategoriesInfoType, APIGameType } from '@/types'
import Typography from '@/components_new/Typography.vue'
import Link from '@/components_new/Link.vue'
import { useGamePlatforms } from '@/pages/Games/utils'
import SeoText from '@/components_new/SeoText.vue'

interface GameCardProps {
    game: APIGameType
    gameCatInfo: GameCategoriesInfoType
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GameDetails',
  props: {
    game: {},
    gameCatInfo: {}
  },
  setup(__props: any) {

const props = __props

const gameDescription = computed(() => {
    let text
    if (props.game.seo_text) {
        text = `${props.game.seo_text}`
    } else {
        text = `${props.game.description}`
        if (props.game.how_to_play_text) {
            text += `\n\n\n\n${props.game.how_to_play_text}`
        }
    }
    text = text.replace(/\n•(.+)/gm, '<li>$1</li>')
    text = text.replace(/(<li>.+<\/li>)+/g, '<ul>$1</ul>')
    text = text.replace(/<p><\/p>/g, '')
    text = text.replace(/\n\n/g, '<br>')
    text = text.replace(/<(\/?)h1>/g, '<$1h2>')
    return text
})

const gamePlatforms = useGamePlatforms(toRef(props.game))

const gameTags = computed(() => {
    return props.gameCatInfo.categoriesInfo.filter((cat) => cat.categoryType === 'tag')
})
const gameCategories = computed(() => props.gameCatInfo.categoriesInfo.filter((cat) => cat.categoryType === 'category'))
const gameSeries = computed(() => {
    return props.gameCatInfo.categoriesInfo.filter((cat) => cat.categoryType === 'series')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.details),
    itemscope: "",
    itemtype: "http://schema.org/WebApplication",
    "data-interface-section": "game-details"
  }, [
    _cache[3] || (_cache[3] = _createElementVNode("meta", {
      itemprop: "applicationCategory",
      content: "Game"
    }, null, -1)),
    _createVNode(Typography, {
      is: "h1",
      size: "xs",
      responsive: false,
      itemprop: "name"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(props.game.title), 1)
      ]),
      _: 1
    }),
    _createElementVNode("meta", {
      itemprop: "image",
      content: props.game.preview
    }, null, 8, _hoisted_1),
    _createElementVNode("meta", {
      itemprop: "url",
      content: `game/${props.game.hru}`
    }, null, 8, _hoisted_2),
    _createElementVNode("div", {
      itemprop: "offers",
      itemscope: "",
      itemtype: "http://schema.org/Offer",
      class: _normalizeClass(_ctx.$style.markup_el)
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("meta", {
        itemprop: "price",
        content: "0"
      }, null, -1),
      _createElementVNode("meta", {
        itemprop: "priceCurrency",
        content: "USD"
      }, null, -1),
      _createElementVNode("meta", {
        itemprop: "availability",
        content: "https://schema.org/InStock"
      }, null, -1)
    ]), 2),
    (props.game.rating)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          itemprop: "aggregateRating",
          itemscope: "",
          itemtype: "http://schema.org/AggregateRating",
          class: _normalizeClass(_ctx.$style.markup_el)
        }, [
          _createElementVNode("meta", {
            itemprop: "ratingValue",
            content: String(props.game.rating.value)
          }, null, 8, _hoisted_3),
          _cache[1] || (_cache[1] = _createElementVNode("meta", {
            itemprop: "bestRating",
            content: "5"
          }, null, -1)),
          _cache[2] || (_cache[2] = _createElementVNode("meta", {
            itemprop: "worstRating",
            content: "1"
          }, null, -1)),
          _createElementVNode("meta", {
            itemprop: "ratingCount",
            content: String(props.game.rating.count)
          }, null, 8, _hoisted_4)
        ], 2))
      : _createCommentVNode("", true),
    (props.game.developer)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          itemprop: "author",
          itemscope: "",
          itemtype: "https://schema.org/Person",
          class: _normalizeClass(_ctx.$style.markup_el)
        }, [
          _createElementVNode("meta", {
            itemprop: "name",
            content: props.game.developer
          }, null, 8, _hoisted_5)
        ], 2))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.game.screenshots, (screenshot, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        itemprop: "screenshot",
        itemscope: "",
        itemtype: "http://schema.org/ImageObject",
        class: _normalizeClass(_ctx.$style.markup_el)
      }, [
        _createElementVNode("meta", {
          itemprop: "thumbnailUrl",
          content: screenshot
        }, null, 8, _hoisted_6)
      ], 2))
    }), 128)),
    _createVNode(Typography, {
      is: "div",
      type: "paragraph",
      size: "xs",
      class: _normalizeClass(_ctx.$style.meta)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.meta__item_key)
          }, _toDisplayString(_ctx.$tr('gameDetails.platforms')) + ": ", 3),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.meta__item_value)
          }, _toDisplayString(_unref(gamePlatforms)), 3)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.meta__item_key)
          }, _toDisplayString(_ctx.$tr('gameDetails.categories')) + ": ", 3),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.meta__item_value)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameCategories.value, (category, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: category.id
              }, [
                _createVNode(Link, {
                  to: category.href,
                  color: "white-80",
                  "data-interface-target": "category",
                  itemprop: "applicationSubCategory"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(category.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createTextVNode(_toDisplayString(index !== gameCategories.value.length - 1 ? ', ' : ''), 1)
              ], 64))
            }), 128))
          ], 2)
        ]),
        (gameTags.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.$style.meta__item_key)
              }, _toDisplayString(_ctx.$tr('gameDetails.tags')) + ": ", 3),
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.$style.meta__item_value)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameTags.value, (tag, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: tag.id
                  }, [
                    _createVNode(Link, {
                      to: tag.href,
                      color: "white-80",
                      "data-interface-target": "tag",
                      itemprop: "applicationSubCategory"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tag.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createTextVNode(_toDisplayString(index !== gameTags.value.length - 1 ? ', ' : ''), 1)
                  ], 64))
                }), 128))
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (gameSeries.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.$style.meta__item_key)
              }, _toDisplayString(_ctx.$tr('gameDetails.series')) + ": ", 3),
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.$style.meta__item_value)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameSeries.value, (series, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: series.id
                  }, [
                    _createVNode(Link, {
                      to: series.href,
                      color: "white-80",
                      "data-interface-target": "series",
                      itemprop: "applicationSubCategory"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(series.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createTextVNode(_toDisplayString(index !== gameSeries.value.length - 1 ? ', ' : ''), 1)
                  ], 64))
                }), 128))
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class"]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.hr)
    }, null, 2),
    _createVNode(SeoText, {
      content: gameDescription.value,
      color: "white-80",
      itemprop: "description"
    }, null, 8, ["content"])
  ], 2))
}
}

})